import React, { useState, useEffect } from "react";

import {
  CardMedia,
  Card,
  CardContent,
  Grid,
  IconButton,
} from "@material-ui/core";
import { HourglassEmpty, DeleteForever, Edit } from "@material-ui/icons";
import ConfirmationModal from "../ConfirmationModal";
import Loading from "../Loading";
import Switch from "./Switch.js";
import url from "../../constants/URL";

const Item = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [updateQuantity, setUpdateQuantity] = useState(false);
  const [newQuantity, setNewQuantity] = useState(0);

  useEffect(() => {
    if (props.items) {
      setData(props.items);
      setLoading(false);
    }
  }, [props.items]);

  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div>
        <div style={{ display: "flex" }}>
          <HourglassEmpty style={{ margin: "19px 15px 19px" }} />
          <h3>No item. Please add some.</h3>
        </div>
      </div>
    );
  }

  async function update_quantity(id, newQuantity) {
    const token = await JSON.parse(window.localStorage.getItem("persist:auth"))
      .token;

    fetch(`${url}/item/quantity/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ newQuantity: newQuantity }),
    })
      .then((res) => {
        window.location.reload();
      })
      .catch((e) => alert(e));
  }

  return (
    <div>
      <Grid container spacing={2}>
        {data.map((Item) => {
          const { _id, name, price, available, images, description, quantity } =
            Item;
          return (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Card
                variant="outlined"
                style={
                  available
                    ? { padding: 0 }
                    : { padding: 0, background: "bisque" }
                }
              >
                <CardContent style={{ padding: 0 }}>
                  <>
                    <h4 style={{ textAlign: "center", marginTop: 4 }}>
                      {name}
                    </h4>
                    <CardMedia
                      component="img"
                      image={images[0]}
                      style={{ height: 190, objectFit: "contain" }}
                    />
                    <div style={{ padding: "20px 10px" }}>
                      <p>
                        <b>Description:</b> {description}
                      </p>

                      <p>
                        <b>price:</b> {price} PKR
                      </p>
                      {quantity ? (
                        <div>
                          {updateQuantity ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              New Quantity:
                              <input
                                type="number"
                                value={newQuantity}
                                onChange={(e) =>
                                  setNewQuantity(Number(e.target.value))
                                }
                                style={{ width: 40, margin: "0 5px" }}
                              />
                              <button
                                disabled={newQuantity === 0}
                                onClick={() =>
                                  update_quantity(_id, newQuantity)
                                }
                              >
                                Done
                              </button>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <p>
                                <b>Quantity:</b> {quantity} Items
                              </p>
                              <IconButton
                                onClick={() => setUpdateQuantity(true)}
                              >
                                <Edit style={{ color: "cornflowerblue" }} />
                              </IconButton>
                            </div>
                          )}
                        </div>
                      ) : (
                        <span>
                          <Switch switch={available} item={true} id={_id} />
                          <b> {available ? "Available" : "Unavailable"}</b>
                        </span>
                      )}
                    </div>
                    {/* <div style={{textAlign:"center"}}>
                                        <Rating name="customized-color" defaultValue={ratings} precision={0.5} size="small" readOnly  />
                                    </div> */}
                  </>
                </CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      setConfirmationModal(true);
                      setDeleteItemId(_id);
                    }}
                  >
                    <DeleteForever style={{ color: "red" }} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      props.history.push(`/update/item/${_id}`);
                    }}
                  >
                    <Edit style={{ color: "cornflowerblue" }} />
                  </IconButton>
                </div>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <ConfirmationModal
        open={confirmationModal}
        handleClose={() => {
          setConfirmationModal(false);
          setDeleteItemId(null);
        }}
        message={"Are you sure to delete this item?"}
        onConfirm={async () => {
          let token = await JSON.parse(
            window.localStorage.getItem("persist:auth")
          ).token;
          fetch(`${url}/${deleteItemId}/item/delete`, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }).then(() => window.location.reload());
        }}
      />
    </div>
  );
};

export default Item;
